import { useMutation } from "@tanstack/react-query";
import { useClientContext } from "clients";

export type InvitationRequestEmailContext = {
  contextId: string;
  email: string;
  firstName: string;
};

/**
 * Hook for sending an invitation request email to an organization admin
 *
 * @returns {useMutation<boolean, BaseError>}
 */
const useSendInvitationRequestEmail = () => {
  const clients = useClientContext();
  return useMutation({
    mutationFn: (input: InvitationRequestEmailContext) =>
      clients.management.requestInvitation({
        context_id: input.contextId,
        email: input.email,
        first_name: input.firstName,
      }),
  });
};

export default useSendInvitationRequestEmail;
